import { render } from "./AIVoiceInteraction.vue?vue&type=template&id=216643d0&scoped=true"
import script from "./AIVoiceInteraction.vue?vue&type=script&lang=js"
export * from "./AIVoiceInteraction.vue?vue&type=script&lang=js"

import "./AIVoiceInteraction.vue?vue&type=style&index=0&id=216643d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216643d0"]])

export default __exports__